import { Document } from "./document.model";

export enum ProcessingStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
    DELETED = 'deleted',
}

export type BaseModel = {
    _id: string;
    createdAt: string;
    updatedAt: string;
}

export interface KnowledgeBaseEmbeddedDocument extends Document {
    title: string;
    description?: string;
    status: ProcessingStatus;
    chunkCount: number;
    pageCount: number;
    processingError?: string;
    processedAt?: Date;
    lastReprocessedAt?: Date;
    qdrantPointIds: string[];
}

export type KnowledgeBaseCollection = BaseModel & {
    name: string;
    description?: string;
    establishment: string;
    documents: KnowledgeBaseEmbeddedDocument[];
};

export type CreateKnowledgeBaseCollectionDto = Pick<KnowledgeBaseCollection, 'name' | 'description'>;

export type UpdateKnowledgeBaseCollectionDto = Partial<CreateKnowledgeBaseCollectionDto>;

export type ReprocessDocumentsDto = {
    documentKeys: string[];
}; 